(function () {
    'use strict';

    angular
        .module('riskEventModule')
        .controller('grcRiskEventFullController', Controller);

    Controller.$inject = ['$scope', '$state', '$mdToast', 'grcRiskEventService', 'historyCtxtService', 'grcRiskService'];

    function Controller($scope, $state, $mdToast, grcRiskEventService, historyCtxtService, grcRiskService) {

        $scope.ctrlCtxt = {};

        grcRiskService.getAllRiskTypes()
            .then(function (riskTypes) {
                $scope.ctrlCtxt.riskTypes = riskTypes;
            });

        // Save Changes
        $scope.saveChanges = function () {
            if ($scope.readOnly) return;

            $scope.boxModel.RiskTypeID = $scope.boxModel.RiskType.RiskTypeID;
            $scope.ctrlCtxt.isLoading = true;

            return grcRiskEventService
                .createOrUpdateRiskEvent($scope.boxModel)
                .then(function (updatedRiskEvent) {
                    $scope.ctrlCtxt.isLoading = false;

                    if ($state.is('riskEventAdd')) {
                        $state.go('riskEventEdit', { RiskEventID: updatedRiskEvent.RiskEventID });
                    }
                    else if (_.isUndefined($scope.boxModel.RiskEventID)) {
                        $state.go('riskEventEdit', { RiskEventID: updatedRiskEvent.RiskEventID });
                    }
                    else {
                        $scope.boxModel = updatedRiskEvent;

                        //$scope.$broadcast('refreshHistoricOnRisk', null);

                        $mdToast.show(
                            $mdToast
                                .simple()
                                .content('Your changes have been saved')
                                .position('top right')
                                .hideDelay($scope.govNotificationDelay)
                                .action('OK')
                                .theme('primary')
                        );

                        $scope.pageIsNotDirty();
                    }
                });
        };

        // Delete Risk Event
        $scope.deleteRiskEvent = function () {
            if ($scope.readOnly) return;
            $scope.ctrlCtxt.isLoading = true;

            return grcRiskEventService
                    .deleteRiskEvent($scope.boxModel.RiskEventID)
                    .then(function () {
                        $scope.ctrlCtxt.isLoading = false;

                        $mdToast.show(
                            $mdToast
                                .simple()
                                .content('Risk Event have been deleted')
                                .position('top right')
                                .hideDelay($scope.govNotificationDelay)
                                .action('OK')
                                .theme('primary')
                        );

                        $scope.pageIsNotDirty();

                        if (!historyCtxtService.getCtxName()) {
                            $state.go('root');
                            return;
                        }

                        historyCtxtService.goToContext();
                    });
        };

        if ($scope.boxModel.PublishedDate) {
            $scope.boxModel.PublishedDate = moment($scope.boxModel.PublishedDate).format();
        } else {
            $scope.boxModel.PublishedDate = moment().format();
        }

        // Custom Methods
        $scope.groupByRiskClass = function (riskType) {
            return riskType.RiskClass.TitleEN;
        };

        $scope.orderRiskClass = function (groups) {
            return _.sortBy(groups, 'name');
        }

        // Show Save Action?
        $scope.showSaveAction = function (form) {
            if ($scope.readOnly) return false;

            return !form.$invalid && $scope.ctxtDir.needSaveChanges;
        };

        // Show Reset Action?
        $scope.showResetAction = function (form) {
            if ($scope.readOnly) return false;

            return $scope.ctxtDir.needSaveChanges;
        };

        // Show Delete Action?
        $scope.showDeleteAction = function () {
            if ($scope.readOnly) return false;

            return !_.isUndefined($scope.boxModel.RiskEventID);
        };

        // Reset forms
        $scope.reset = function () {
            if ($scope.readOnly) return;
            $state.reload();
        };
    }

})();